import {Reducer, PayloadAction} from "@reduxjs/toolkit";

export type CardPaymentModeDto = "ALL" | "WHITELIST";

export type PaymentConfigState = {
    loaded: boolean;
    stripePercentFee: number;
    stripeFixedFeeUsd: number;
    stripePaymentToleranceUsd: number;
    cardPaymentMode: CardPaymentModeDto;
    cardPaymentAllowed: boolean;
};

const initial: PaymentConfigState = {
    loaded: false,
    stripePercentFee: 0.029,
    stripeFixedFeeUsd: 0.3,
    stripePaymentToleranceUsd: 0,
    cardPaymentMode: "ALL",
    cardPaymentAllowed: true,
};

export const PaymentConfigActionTypes = {
    SET_CLIENT_CONTEXT: "paymentConfig/setClientContext",
    RESET: "paymentConfig/reset",
} as const;

export const PaymentConfigReducer: Reducer<PaymentConfigState, PayloadAction<Partial<PaymentConfigState>>> = (
    state = initial,
    action
) => {
    switch (action.type) {
        case PaymentConfigActionTypes.SET_CLIENT_CONTEXT:
            return {
                ...state,
                loaded: true,
                ...action.payload,
            };
        case PaymentConfigActionTypes.RESET:
            return {...initial, loaded: false};
        default:
            return state;
    }
};
